import React, { useContext } from 'react';

import { colors, Row, Col, Typography, MessageBox } from '@ajaibid/components';
import { formatCurrency } from '@ajaibid/utils';
import { FirebaseContext } from '@/context/firebase';

import { useMtCalculation, useStockBuySellContext } from '../../hooks';
import { styConfirmationNotes, styConfirmationNotesList } from '../../style';

function renderDtDisclaimers(disclaimers = []) {
  if (!disclaimers || disclaimers?.length === 0) return null;
  if (disclaimers?.length === 1) {
    return disclaimers[0];
  }
  return (
    <ul className={styConfirmationNotesList}>
      {disclaimers.map((v, i) => (
        <li key={i}>{v}</li>
      ))}
    </ul>
  );
}

const OrderNotes = () => {
  const {
    flags: { STOCK_DT_CONFIRM_DISCLAIMER },
  } = useContext(FirebaseContext);

  const { isBuy, isSell, isAccountDT, isAccountMT } = useStockBuySellContext();
  const { mtCashUsed, mtLoanUsed } = useMtCalculation();

  const dtDisclaimers = STOCK_DT_CONFIRM_DISCLAIMER?.disclaimers || [];
  return (
    <>
      {isAccountDT && isBuy && (
        <div className={styConfirmationNotes} style={{ marginBottom: 16 }} data-testid="info-dtBuy">
          <Typography type="body" color={colors.NEUTRAL_7} margin={0}>
            {renderDtDisclaimers(dtDisclaimers)}
          </Typography>
        </div>
      )}
      {isAccountMT && isBuy && (
        <div className={styConfirmationNotes} style={{ marginBottom: 16 }} data-testid="info-mtBuy">
          <Row noGutters align="between">
            <Col size="auto">
              <Typography type="body" color={colors.NEUTRAL_7} margin={0}>
                Dana Terpakai
              </Typography>
            </Col>
            <Col size="auto">
              <Typography type="body" bold margin={0}>
                {formatCurrency(mtCashUsed, 'IDR')}
              </Typography>
            </Col>
          </Row>
          <Row noGutters align="between" marginTop={8}>
            <Col size="auto">
              <Typography type="body" color={colors.NEUTRAL_7} margin={0}>
                Margin Terpakai
              </Typography>
            </Col>
            <Col size="auto">
              <Typography type="body" bold margin={0}>
                {formatCurrency(mtLoanUsed, 'IDR')}
              </Typography>
            </Col>
          </Row>
        </div>
      )}
      {isAccountMT && isSell && (
        <MessageBox type="info" style={{ marginBottom: 16 }} data-testid="info-mtSell">
          Jika terdapat margin, sebagian hasil penjualan akan digunakan untuk membayar margin yang
          digunakan.
        </MessageBox>
      )}
    </>
  );
};

export default OrderNotes;
